import MatchedPhoto from './MatchedPhoto';

export default MatchedPhoto;
